import { first } from 'rxjs/operators';
import {ExpenseDetailService} from '@app/_components/expense/components/expense-detail/expense-detail.service';
import {ExpenseDetail} from '@app/_components/expense/components/expense-detail/expense-detail';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExpenseDetailComponent  } from '@app/_components/expense/components/expense-detail/expense-detail/expense-detail.component';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-expense-detail-list',
    templateUrl: './expense-detail-list.component.html',
    styleUrls: ['./expense-detail-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ExpenseDetailListComponent implements OnInit {
	constructor(
		private expenseDetailService: ExpenseDetailService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = expenseDetailService.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Input() expenseId: any;
	expenseDetails: any;
	expenseDetail: ExpenseDetail;
	paidByList = {
		1: 'KBM',
		2: 'Owner',
		3: 'Vendor'
	};
	paidByOptions = [
		{ label: 'KBM', value: 1 },
		{ label: 'Owner', value: 2 },
		{ label: 'Vendor', value: 3 }
	];

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

  topics: any;

	columns: any[] = [
		{ field: 'description', header: 'Description', width: 'auto' },
		{ field: 'quantity', header: '#', width: 'auto' },
		{ field: 'paidBy', header: 'Paid By', width: 'auto' },
		{ field: 'amount', header: 'Price', width: 'auto' },
		{ field: 'subTotal', header: 'Sub Total', width: 'auto' },
		{ field: 'tax', header: 'Tax', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.expenseDetailId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-expenseDetail-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if(this.expenseId)
				{
					// show only shortTermRentals that are assigned to this propertyCodeFilter
					let expenseIdFilter = { 'expenseVO.expenseId': { 'value': this.expenseId, 'matchMode': 'in' } };
					Object.assign(event.filters, expenseIdFilter);
				}

			const pageNumber = Math.round(event.first / event.rows);
			this.formLoading = true;
			this.expenseDetailService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.expenseDetails = res.data.expenseDetails;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { 
						this.loading = false; 
						this.formLoading = false;
					}
				);

			if (this.datasource) {
				this.expenseDetails = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onCellEditComplete()
	 * Fires when inline cell editing exits (tab, enter, or click away).
	 * Also called directly from the paidBy dropdown onChange.
	 */
	onCellEditComplete(event: any) {
		const row = event.data;
		if (row && row.expenseDetailId) {
			this.formUpdate(row);
		}
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(expenseDetail: ExpenseDetail) {
		try {
			this.formLoading = true;
			this.expenseDetailService.update(expenseDetail)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.expenseDetails.map((expenseDetail, i) => {
							if (expenseDetail.expenseDetailId === res.data.expenseDetail.expenseDetailId) {
								this.expenseDetails[i] = res.data.expenseDetail;
							}
						});
						// Spread to a new array so Angular change detection picks up the updated subTotal / tax / total
						this.expenseDetails = [...this.expenseDetails];
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(expenseDetail: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(expenseDetail));

			this.formLoading = true;
			this.expenseDetailService.delete(expenseDetail.expenseDetailId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.expenseDetails.splice(this.expenseDetails.indexOf(expenseDetail), 1);
						this.recordTotal = this.expenseDetails.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'ExpenseDetail ' + expenseDetail.expenseDetailId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'ExpenseDetail ' + expenseDetail.expenseDetailId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = '60vw';
		dialogConfig.height = '80vh';
		dialogConfig.panelClass = 'ctm-fix-height-popup';
		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add ExpenseDetail',
			expenseId: this.expenseId,
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ExpenseDetailComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addExpenseDetailCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(expenseDetail: any) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = '60vw';
		dialogConfig.height = '80vh';
		dialogConfig.panelClass = 'ctm-fix-height-popup';
		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			expenseDetail: expenseDetail,
			title: 'Edit ExpenseDetail',
			expenseId: this.expenseId,
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ExpenseDetailComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateExpenseDetailCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteExpenseDetailCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addExpenseDetailCB(expenseDetail: ExpenseDetail) {
		console.log('Adding ExpenseDetail: ' + JSON.stringify(expenseDetail));
		// if we don't have a expenseDetails array yet...
		if (!this.expenseDetails) {
			this.expenseDetails = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.expenseDetails.unshift(expenseDetail);

		// no idea what this is but it is required to update the array
		this.expenseDetails = [...this.expenseDetails];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ExpenseDetail ' + expenseDetail.expenseDetailId + ' Added', life: 3000 });
	}

	updateExpenseDetailCB(expenseDetail: ExpenseDetail) {
		console.log('Updating ExpenseDetail: ' + JSON.stringify(expenseDetail));
		let itemIndex = this.expenseDetails.findIndex((item: any) => item.expenseDetailId === expenseDetail.expenseDetailId);
		this.expenseDetails[itemIndex] = expenseDetail;

		// no idea what this is but it is required to update the array
		this.expenseDetails = [...this.expenseDetails];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ExpenseDetail ' + expenseDetail.expenseDetailId + ' Updated', life: 3000 });
	}

	deleteExpenseDetailCB(expenseDetail: ExpenseDetail) {
		console.log('Removing ExpenseDetail: ' + expenseDetail);
		this.expenseDetails.splice(this.expenseDetails.indexOf(expenseDetail), 1);
		this.recordTotal = this.expenseDetails.length;

		// no idea what this is but it is required to update the array
		this.expenseDetails = [...this.expenseDetails];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ExpenseDetail ' + expenseDetail.expenseDetailId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.expenseDetails ? this.first === (this.expenseDetails.length - this.rows) : true; }
	isFirstPage(): boolean { return this.expenseDetails ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(expenseDetail: any) {
		if (expenseDetail?.status) {
			const status = this.statuses.find((e: any) => e.value == expenseDetail.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	grandTotal(){
		let total = 0
		this.expenseDetails.forEach(orderDetail => {
			total += orderDetail?.total
		});
		return total;
	}

	totalTax(){
		let total = 0
		this.expenseDetails.forEach(orderDetail => {
			total += orderDetail?.tax
		});
		return total;
	}
	totalAmount(){
		let total = 0
		this.expenseDetails.forEach(orderDetail => {
			total += orderDetail?.subTotal
		});
		return total;
	}
}
